@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Brand Header -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between px-5 py-1 relative flex-wrap gap-2"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Driver Performance & Analytics
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center gap-2 flex-wrap">
      @if (fromUrbanDashboard) {
      <button
        (click)="goBackToDashboard()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <span nz-icon nzType="left" nzTheme="outline"></span>
        Go Back
      </button>
      } @if (filters == true) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Hide Filters
      </button>
      } @if (filters == false) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Show Filters
      </button>
      }
    </div>
  </div>
</div>

<div class="driver-slider">
  <!-- Enhanced Modern Filter Section - Tailwind CSS -->
  @if (filters) {
  <div
    class="bg-gradient-to-r from-slate-50 to-gray-50 rounded-xl shadow-sm p-4 mb-3 border border-gray-200 fltrsctn"
  >
    <div class="flex items-center gap-3 flex-wrap">
      <!-- ULB Filter -->
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >ULB</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="Select ULB"
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          @for (t of tntLst; track t) {
          <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
          }
        </nz-select>
      </div>
      <!-- Vehicle Vendor Filter -->
      @if (ShowClap) {
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >Vehicle Vendor</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="Select Vendor"
          [(ngModel)]="selectedvndr"
          (ngModelChange)="onvndrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          @if (!showVndr) {
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          } @for (v of vendorList; track v) {
          <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
          }
        </nz-select>
      </div>
      }
      <!-- Driver Filter -->
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >Select Driver</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="Select Driver"
          [(ngModel)]="selectedrvr"
          (ngModelChange)="ondrvrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          @for (d of drvrslst; track d) {
          <nz-option [nzValue]="d.crw_id" [nzLabel]="d.crw_nm"></nz-option>
          }
        </nz-select>
      </div>
    </div>
  </div>
  }

  <!-- Driver Profile + Attendance Sticky Section -->
  @if (crwDtls && crwDtls.crw_nm) {
  <div class="slider-header">
    <div class="header-content">
      <!-- Driver Profile -->
      <div class="driver-profile">
        <div class="avatar-wrapper">
          <img
            src="../../../../../assets/images/driver.png"
            alt="Driver"
            class="avatar-img"
          />
          <span
            class="status-dot"
            [class.online]="drvrDtls && drvrDtls[0]?.asrtglblId == '1'"
          ></span>
        </div>
        <div class="profile-details">
          <h1 class="driver-name">
            {{ crwDtls.crw_nm || "Driver Name" }}
            <span
              class="own-hired-badge"
              [ngClass]="{
                'own-badge': crwDtls.own_in == 1,
                'hired-badge': crwDtls.own_in == 2,
                'apcos-badge': crwDtls.own_in == 3
              }"
            >
              {{
                crwDtls.own_in == 1
                  ? "Own"
                  : crwDtls.own_in == 2
                  ? "Hired"
                  : crwDtls.own_in == 3
                  ? "APCOS"
                  : ""
              }}
            </span>
          </h1>
          <div class="meta-info">
            <span class="meta-item">
              <i nz-icon nzType="phone" nzTheme="outline"></i>
              {{
                !crwDtls.crw_ph || crwDtls.crw_ph == 0
                  ? "Not Provided"
                  : crwDtls.crw_ph
              }}
            </span>
            <span class="meta-item">
              <i nz-icon nzType="idcard" nzTheme="outline"></i>
              {{
                !crwDtls.crw_lcnse_nu || crwDtls.crw_lcnse_nu == "undefined"
                  ? "Not Provided"
                  : crwDtls.crw_lcnse_nu
              }}
            </span>
          </div>
          @if (crwDtls.asrt_nm) {
          <div class="vehicle-info">
            <i nz-icon nzType="car" nzTheme="outline"></i>
            <span>{{ crwDtls.asrt_nm }}</span>
            @if (crwDtls.asrt_sts_nm) {
            <span
              class="vehicle-badge"
              [ngStyle]="{
                'background-color': crwDtls.bg_clr_cd,
                color: crwDtls.clr_cd
              }"
            >
              {{ crwDtls.asrt_sts_nm }}
            </span>
            }
          </div>
          } @if (clntDtls[0].clnt_id==7 && crwDtls.svm_nm) {
          <div class="sachivalayam-info">
            <i nz-icon nzType="environment" nzTheme="outline"></i>
            <span>{{ crwDtls.svm_nm }}</span>
          </div>
          }
        </div>
      </div>
      <!-- Attendance Section with Pie Chart -->
      <div class="attendance-section">
        <div class="attendance-chart">
          <nz-progress
            [nzPercent]="attendanceData.percentage"
            [nzStrokeColor]="
              attendanceData.percentage >= 80
                ? '#10b981'
                : attendanceData.percentage >= 50
                ? '#f59e0b'
                : '#ef4444'
            "
            [nzShowInfo]="true"
            nzType="circle"
            [nzWidth]="80"
            [nzStrokeWidth]="10"
          >
          </nz-progress>
          <div class="attendance-label">Attendance</div>
        </div>
        <div class="attendance-stats">
          <div class="att-stat present">
            <span class="att-count">{{ attendanceData.daysPresent }}</span>
            <span class="att-text">Present</span>
          </div>
          <div class="att-stat absent">
            <span class="att-count">{{
              attendanceData.totalDays - attendanceData.daysPresent
            }}</span>
            <span class="att-text">Absent</span>
          </div>
        </div>
        <!-- Attendance Days (Last 7 Days) -->
        @if (attendanceDays && attendanceDays.length > 0) {
        <div class="attendance-days">
          @for (day of attendanceDays; track day; let i = $index) {
          <div
            class="day-item"
            [class.present]="day.operated === 1"
            [class.absent]="day.operated === 0"
            [nz-tooltip]="
              day.dt + ' - ' + (day.operated === 1 ? 'Present' : 'Absent')
            "
          >
            <span class="day-date">{{ getAttendanceDate(i) }}</span>
            <i
              nz-icon
              [nzType]="day.operated === 1 ? 'check-circle' : 'close-circle'"
              nzTheme="fill"
            ></i>
          </div>
          }
        </div>
        }
      </div>
      <!-- Stats -->
      <div class="header-stats">
        <div class="stat-box">
          @if (drvrDtls && drvrDtls.length>1 && drvrDtls[1]) {
          <div class="stat-value">
            {{ drvrDtls[0].trvl_trp_cnt || "0" }}
          </div>
          } @if (!drvrDtls || drvrDtls.length<=1 || !drvrDtls[1]) {
          <div class="stat-value">0</div>
          }
          <div class="stat-label">Today's Trips</div>
        </div>
        <div class="stat-box">
          @if (drvrTtlDtls && drvrTtlDtls.length>0) {
          <div class="stat-value">
            {{ drvrTtlDtls[0][0].tot_dst || "0" }}
            <small>km</small>
          </div>
          } @if (!drvrTtlDtls || drvrTtlDtls.length<=0) {
          <div class="stat-value">0 <small>km</small></div>
          }
          <div class="stat-label">Distance</div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Map & Heatmap Side by Side -->
  <div class="map-heatmap-grid">
    <!-- Map Card -->
    <div class="card map-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            ></path>
          </svg>
          <h3>Current Location</h3>
        </div>
      </div>
      <div class="card-body no-padding">
        <div id="driverMap" style="height: 320px; width: 100%"></div>
      </div>
    </div>

    <!-- Heat Chart Card -->
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
            ></path>
          </svg>
          <h3>24/7 Distance Coverage</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div
          id="hepachartdiv"
          [style.display]="noHourlyData ? 'none' : 'block'"
          style="height: 320px; width: 100%"
        ></div>
        @if (noHourlyData) {
        <div class="empty-state">
          <i nz-icon nzType="dot-chart" nzTheme="outline"></i>
          <p>No data found</p>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="charts-section">
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #8b5cf6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            ></path>
          </svg>
          <h3>Distance Travelled</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div
          id="lastSevenDaysDistanceChart"
          [style.display]="!drvrDtls || drvrDtls.length <= 0 ? 'none' : 'block'"
          style="height: 280px; width: 100%"
        ></div>
        @if (!drvrDtls || drvrDtls.length <= 0) {
        <div class="empty-state">
          <i nz-icon nzType="line-chart" nzTheme="outline"></i>
          <p>No distance data available</p>
        </div>
        }
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #10b981"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
          <h3>Trips Completed</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div
          id="lastSevenDaysChart"
          [style.display]="!drvrDtls || drvrDtls.length <= 0 ? 'none' : 'block'"
          style="height: 280px; width: 100%"
        ></div>
        @if (!drvrDtls || drvrDtls.length <= 0) {
        <div class="empty-state">
          <i nz-icon nzType="bar-chart" nzTheme="outline"></i>
          <p>No trips data available</p>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Tables Section -->
  <div class="tables-section">
    <div class="card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
            ></path>
          </svg>
          <h3>Operational Details</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (drvrOptnlDtls && drvrOptnlDtls.length>0) {
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Vehicle</th>
                <th>Category</th>
                <th>Hours</th>
                <th>Distance</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (o of drvrOptnlDtls; track o) {
              <tr>
                <td>{{ o.dt }}</td>
                <td class="text-primary">{{ o.asrt_nm }}</td>
                <td>{{ o.asrt_ctgry_nm }}</td>
                <td>{{ o.oprtn_hrs_ct }}</td>
                <td>{{ o.dst }} km</td>
                <td>
                  <span
                    class="status-pill"
                    [class.success]="o.operated == 1"
                    [class.warning]="o.operated == 0"
                  >
                    {{ o.operated == 1 ? "Operated" : "Not Operated" }}
                  </span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if ((!drvrOptnlDtls || drvrOptnlDtls.length === 0) && oprtnlhrsMsg) {
        <div class="empty-state">
          <i nz-icon nzType="file-text" nzTheme="outline"></i>
          <p>{{ oprtnlhrsMsg }}</p>
        </div>
        }
      </div>
    </div>

    <div class="card">
      <div class="card-header warning">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #f59e0b"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            ></path>
          </svg>
          <h3>Speed Violations</h3>
        </div>
        <span class="badge warning">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (drvrSpdDtls && drvrSpdDtls.length>0) {
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Vehicle</th>
                <th>Category</th>
                <th>Speed</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              @for (t of drvrSpdDtls; track t) {
              <tr>
                <td>{{ t.dt }}</td>
                <td class="text-primary">{{ t.asrt_nm }}</td>
                <td>{{ t.asrt_ctgry_nm }}</td>
                <td class="text-danger font-medium">{{ t.speed }} km/h</td>
                <td>
                  <a
                    class="link-btn"
                    href="https://www.google.com/maps/search/?api=1&query={{
                      t.r_lat
                    }},{{ t.r_lng }}"
                    target="_blank"
                  >
                    <i nz-icon nzType="environment" nzTheme="outline"></i>
                    View
                  </a>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (fuelDtaMsg) {
        <div class="empty-state success">
          <i nz-icon nzType="safety-certificate" nzTheme="outline"></i>
          <p>{{ fuelDtaMsg }}</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>
